<template>
  <div class="wrapper">
    <ul class="tableList">
      <li
        v-for="(item, index) in tableDate"
        :style="{ height: `${100 / tableDate.length}%` }"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["tableDate"],
  components: {},
  data() {
    return {
      initHeight: "",
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 100%;
  .tableList {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    li {
      border-bottom: 1px solid #e8eaec;
      padding: 5px;
      min-height: 32px;
      line-height: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>